import React from "react";
import useModal from "hooks/useModal";
import SigninModal from "components/Signup/Modal/SigninModal";
import { getIsUser } from "utils/utility";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const isUser = getIsUser();

  const { isOpen, openModal, closeModal } = useModal();

  if (!isUser) {
    if (!isOpen) openModal();
    return <SigninModal modalClose={closeModal} />;
  }
  return <>{children}</>;
};

export default PrivateRoute;
